import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { VistaService } from 'src/app/services/service.index';

declare var toastr;

@Component({
  selector: 'app-vista',
  templateUrl: './vista.component.html',
  styles: []
})
export class VistaComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourceV: any[];
  dataResourceM: any[];
  dataResourceTipo: any[];
  model: any = {
    id: 0,
    modulo_id: 0,
    uri: '',
    posicion: 0,
    titulo: '',
    descripcion: '',
    tipo_acceso: '',
    icono: '',
    estado: '',
  };

  modelM: any = {
    id:0,
    modulo:'',
    tipo_acceso:'',
    descripcion: '',
    posicion:0,
    icono: ''
  };
  idRol: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleAddModulo: boolean = false;
  state_toogle: boolean = false;
  baseUrl = environment.apiEndpoint;
  hasError: any;
  hasErrorM: any;

  constructor(private _ss: VistaService) {
    this.clearErrors();
    this.clearErrorsM();
    this.getVistas();
    this.getModulos();
    this.dataResourceTipo = [{ tipo_acceso: 'privado' }, { tipo_acceso: 'público'}];
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { id: false, descripcion: false, modulo_id: false, icono: false, uri: false, posicion: false, estado: false, titulo: false };
  }

  clearErrorsM() {
    this.hasErrorM = { id: false, descripcion: false, tipo_acceso: false, icono: false, modulo: false, posicion: false };
  }

  getModulos() {
    this._ss.getModulos().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.dataResourceM = result.data;
        } else {
          this.dataResourceM = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getVistas() {
    this._ss.getVistas().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {          
          this.dataResourceV = result.data;
        } else {
          this.dataResourceV = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.uri = '';
    this.model.titulo = '';
    this.model.descripcion = '';
    this.model.icono = '';
    this.model.posicion = '';
    this.state_toogle = false;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.clearErrors();
    this.model.id = data.id;
    this.model.modulo_id = data.modulo_id;
    this.model.uri = data.uri;
    this.model.posicion = data.posicion;
    this.model.titulo = data.titulo;
    this.model.descripcion = data.descripcion;
    this.model.tipo_acceso = data.tipo_acceso;
    this.model.icono = data.icono;
    this.model.estado = data.estado;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
  }

  showModalAddModulo(){
    this.popupVisibleAddModulo = true;
  }

  saveVista() {
    this.hasError = { descripcion: false };
    if (this.validate(this.model)) {
      if (this.model.id == 0) {        
        this._ss.postVista(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getVistas();
              this.popupVisibleAdd = false;
              toastr.success('Rol adicionado exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
      else {        
        this._ss.putVista(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getVistas();
              this.popupVisibleAdd = false;
              toastr.success('Rol actualizado exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.idRol = id;
    this.popupVisibleDel = true;
  }

  deleteVista() {
    this._ss.deleteVista(this.idRol).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getVistas();
          this.popupVisibleDel = false;
          toastr.success('Eliminado correctamente.');
        } else {
          this.getVistas();
          this.popupVisibleDel = false;
          toastr.warning(result.data);
        }
      },
      error => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    if (!UtilHelper.validator(data.titulo, 'text')) {
      this.hasError.titulo = true; res = false;
    }
    if (!UtilHelper.validator(data.uri, 'text')) {
      this.hasError.uri = true; res = false;
    }
    return res;
  }

  saveModulo(){   
 
    if (this.validateM(this.modelM)) {              
        this._ss.postModulo(this.modelM).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getModulos();
              this.popupVisibleAddModulo = false;
              toastr.success('Módulo adicionado exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
  }
  validateM(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasErrorM.descripcion = true; res = false;
    }
    if (!UtilHelper.validator(data.modulo, 'text')) {
      this.hasErrorM.modulo = true; res = false;
    }
    if (!UtilHelper.validator(data.icono, 'text')) {
      this.hasErrorM.icono = true; res = false;
    }
    if (!UtilHelper.validator(data.posicion, 'text')) {
      this.hasErrorM.posicion = true; res = false;
    }
    return res;
  }

}
